var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.action.class,style:(_vm.action.style),attrs:{"to":_vm.action.to}},[_vm._v(_vm._s(_vm.action.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }